<template>
  <b-modal
    :active="true"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-modal
  >
    <div class="modal-card reorder-modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Reorder documents</p>
      </header>

      <section class="modal-card-body">
        <draggable
          v-model="items"
          handle=".reorder-handle"
          ghost-class="reorder-ghost"
        >
          <div
            v-for="item in items"
            :key="item.id"
            class="reorder-row reorder-handle"
          >
            <span>☰</span>
            <span>{{ item.name }}</span>
          </div>
        </draggable>
      </section>

      <footer class="modal-card-foot">
        <b-button @click="close"> Close </b-button>
        <b-button type="is-primary" @click="saveReorderedItems">
          Save order
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'ReorderModal',
  components: {
    draggable,
  },

  props: {
    reorderItems: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      items: this.reorderItems,
    };
  },

  methods: {
    saveReorderedItems() {
      this.$emit('saveReorderedItems', this.items);
      this.close();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}

.reorder-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #fff;
  cursor: grab;
  user-select: none;
}

.reorder-ghost {
  opacity: 0.5;
}
</style>
